/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {PipesModule} from '../pipes/pipes.module';
import {GlobalSearchCriteriaComponent} from './global-search-criteria.component';
import {DropdownCriteriaSelectionComponent} from './dropdown-criteria-selection/dropdown-criteria-selection.component';
import {QueryChipsAreaComponent} from './query-chips-area/query-chips-area.component';
import {TooltipModule} from '../tooltip/tooltip.module';
import {InputCriteriaTypeModule} from './input-criteria-type/input-criteria-type.module';

@NgModule({
    declarations: [
        GlobalSearchCriteriaComponent,
        DropdownCriteriaSelectionComponent,
        QueryChipsAreaComponent
    ],
    exports: [
        GlobalSearchCriteriaComponent
    ],
    imports: [
        CommonModule,
        NgbDropdownModule,
        PipesModule,
        TooltipModule,
        InputCriteriaTypeModule
    ]
})
export class GlobalSearchCriteriaModule {
}
